import svShowImage from './sv-show-image.vue'
export default svShowImage